import { render, staticRenderFns } from "./VSpacerWrapper.vue?vue&type=template&id=d1ee4c30"
import script from "./VSpacerWrapper.vue?vue&type=script&lang=js"
export * from "./VSpacerWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports